// extracted by mini-css-extract-plugin
module.exports = {"totalSummary":"styles_totalSummary__InwAY","free":"styles_free__TjjS5"};